import { NoSsr } from "@material-ui/core";
import * as Sentry from "@sentry/node";
import Head from "next/head";
import React from "react";
import analytics from "../analytics";
import { App } from "../components/App";
import { AppContextProvider } from "../context/AppContext";
import { UserContextProvider } from "../context/UserContext";
import "../index.css";

if (process.env.REACT_APP_SENTRY_DSN)
  Sentry.init({
    enabled: process.env.NODE_ENV === "production",
    dsn: process.env.REACT_APP_SENTRY_DSN,
  });

const BUILD_ID = process.env.REACT_APP_BUILD_ID;
const SEGMENT_KEY = process.env.REACT_APP_SEGMENT_KEY;

if (SEGMENT_KEY && typeof window !== "undefined") {
  analytics.load(SEGMENT_KEY);
  analytics.identify(undefined, {
    integrations: {
      All: true,
      FullStory: false,
    },
    context: {
      app: {
        name: window.location.host,
        build: BUILD_ID,
      },
    },
    // TODO SegmentAnalytics.SegmentOpts
  } as any);

  // Track initial url
  analytics.page({
    href: window.location.href,
    host: window.location.host,
  });
}

function MyApp(props) {
  const { Component, pageProps, err } = props;

  return (
    <React.Fragment>
      <Head>
        <title>Reclaim – Defend your life from work</title>
      </Head>
      <AppContextProvider>
        <UserContextProvider>
          <App>
            <NoSsr>
              <Component {...pageProps} err={err} />
            </NoSsr>
          </App>
        </UserContextProvider>
      </AppContextProvider>
    </React.Fragment>
  );
}

export default MyApp;
